import { Col, DatePicker, Form, InputNumber, Modal, Row } from 'antd';
import styled from 'styled-components';
import TextArea from 'antd/lib/input/TextArea';
import moment from 'moment';

import { Invoice } from '../../modules/invoices';

const StyledDiv = styled.div``;

interface CreateInvoicePaymentModalProps {
  visible: boolean;
  invoice: Invoice;
  onCreate: (value: any) => void;
  onCancel: () => void;
}

function CreateInvoicePaymentModal({
  visible,
  invoice,
  onCreate,
  onCancel,
}: CreateInvoicePaymentModalProps) {
  const [form] = Form.useForm();
  return (
    <StyledDiv>
      <Modal
        open={visible}
        title="청구서 지급금 입력하기"
        okText="확인"
        cancelText="취소"
        onCancel={onCancel}
        onOk={() => {
          form
            .validateFields()
            .then((values) => {
              // form.resetFields();
              onCreate(values);
            })
            .catch((info) => {
              console.error('Validate Failed:', info);
            });
        }}
      >
        <>
          <Form
            form={form}
            layout="horizontal"
            initialValues={{
              amount:
                invoice.price -
                invoice.payments.reduce((acc, cur) => acc + cur.amount, 0),
              paymentDate: moment(),
            }}
          >
            <Row justify="center">
              <Col span={16}>
                <Form.Item
                  name="amount"
                  label="지급액(원)"
                  rules={[
                    {
                      required: true,
                    },
                  ]}
                >
                  <InputNumber
                    style={{ width: '100%' }}
                    formatter={(value) =>
                      `₩ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                    }
                    parser={(value) => value!.replace(/₩\s?|(,*)/g, '')}
                    // onChange={updateSupplyPriceField}
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row justify="center">
              <Col span={16}>
                <Form.Item
                  name="paymentDate"
                  label="지급일"
                  rules={[
                    {
                      required: true,
                    },
                  ]}
                >
                  <DatePicker format="YYYY-MM-DD" style={{ width: '100%' }} />
                </Form.Item>
              </Col>
            </Row>
            <Row justify="center">
              <Col span={16}>
                <Form.Item name="description" label="설명">
                  <TextArea rows={2} />
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </>
      </Modal>
    </StyledDiv>
  );
}

export default CreateInvoicePaymentModal;
